import { useProfile } from '@/hooks/useProfile';
import { analyticsHistoryDays, isPremiumActive } from '@/lib/premiumFeatures';

/**
 * Client-side Premium state (backed by `profiles.subscription_*`).
 * App Store purchase flow is not wired yet — see `premiumFeatures.ts` header.
 */
export function usePremium() {
  const { profile, refetch } = useProfile();
  const isPremium = isPremiumActive(profile ?? null);
  return {
    isPremium,
    subscriptionTier: profile?.subscription_tier ?? 'free',
    subscriptionExpiresAt: profile?.subscription_expires_at ?? null,
    analyticsHistoryDays: analyticsHistoryDays(isPremium),
    refetchProfile: refetch,
  };
}
